export const VALUATION_SUMMARY_SPREADSHEET_HEADER_TITLE = 'VALUATION_SUMMARY_SPREADSHEET_HEADER_TITLE';
export const VALUATIONS_SUMMARY_SPREADSHEET_TOTAL = 'VALUATIONS_SUMMARY_SPREADSHEET_TOTAL';
